import React, { useEffect } from 'react';
import partnerBanner from '../img/envision/aboutdd/pppss.JPG';
import AboutPartnersbanner from './AboutPartnersbanner';
import Aboutpatnersectionfirst from './Aboutpatnersectionfirst';
import Aboutwithparthers from './Aboutwithparthers';
import AboutqualityBanner from './AboutqualityBanner';
import Aboutqualitysection from './Aboutqualitysection';
import Aboutusobjectives from './Aboutusobjectives';
import AboutQualityCards from './AboutQualityCards';
import AboutqualityCertificatecards from './AboutqualityCertificatecards';
const AboutQuality = () => {
       useEffect(() => {
            window.scrollTo(0, 0);
          }, []); // Empty dependency array ensures it only runs once when the component mounts
                  // Scroll to the top of the page when the component mounts
         
    return (
        <div style={{ backgroundColor: '#fff' }}>
            {/* <AboutPartnersbanner /> */}
            <AboutqualityBanner />
            {/* <Aboutpatnersectionfirst /> */}
            <Aboutqualitysection />
            {/* <Aboutwithparthers /> */}
            <Aboutusobjectives />
            <AboutQualityCards />
            <AboutqualityCertificatecards />
        </div>
    );
};

export default AboutQuality;
